var React = require('react');

function Google (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.6672 13.7867C16.6597 15.5802 16.6672 17.3736 16.6748 19.167C19.6815 19.265 22.6956 19.2197 25.7023 19.265C24.3761 25.9339 15.3034 28.0965 10.5033 23.7411C5.56753 19.9206 5.80113 11.5412 10.9328 7.99197C14.5197 5.12847 19.6212 5.83677 23.208 8.31597C24.6172 7.01237 25.9358 5.61827 27.2093 4.17147C24.2253 1.79027 20.5631 0.0947679 16.6672 0.275668C8.53653 0.00436786 1.06133 7.12537 0.925733 15.2562C0.405733 21.9024 4.77633 28.4206 10.9479 30.7717C17.0968 33.1378 24.9789 31.5252 28.9049 26.0017C31.4971 22.5128 32.0547 18.0217 31.7533 13.8018C26.7195 13.7641 21.6934 13.7716 16.6672 13.7867Z","fill":"#231F20"}));
}

Google.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Google;

Google.default = Google;
